import {  MenuItem, Chip, Autocomplete, IconButton, Popover, Button, TextField, Card, Grid, Typography, Switch, Box, Tooltip, Stack, Dialog, DialogContent, DialogTitle, DialogActions, Divider } from '@mui/material';
import MergeTypeIcon from '@mui/icons-material/MergeType';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { getStateAlerts } from '../../../api/orders';
import { postIsApproveEnabled, postSplitRentalOrder, updateRentalOrder, postSplitRentalPunchoutOrder} from '../../../api/rentals';
import { useTabs } from '../../../context/TabContext';
import {
    addRentalLogRedux,
    clearFacilityVendors,
    editPersonFor,
    getRentalOrdersRedux,
    getRentalRecipientsRedux,
    getUnreadRentalCount,
    getResidentsForFacility,
    postAddCopiedUsers,
    postDeleteCopiedUser,
    updateOrderItemInRedux,
    updateOrderStatus,
    updateShortLongTerm,
    editSerialNumber
} from '../../../redux/slices/rentals';
import { useDispatch, useSelector } from '../../../redux/store';
import { AwaitButton } from '../../../reusable-components/await-button';
import CloseIconButton from '../../../reusable-components/basic-buttons/CloseIconButton';
import { CollapseSidebar } from '../../../reusable-components/collapse-sidebar';
import { ConfirmDialog } from '../../../reusable-components/confirm-dialog';
import { CustomAvatar } from '../../../reusable-components/custom-avatar';
import CustomDataGrid from '../../../reusable-components/datagrid/CustomDataGrid';
import ManagerChips from '../../../reusable-components/datagrid/ManagerChips';
import { RENTAL_ORDER_ITEMS } from '../../../reusable-components/datagrid/rentalColumns';
import Iconify from '../../../reusable-components/iconify';
import { useScopeCheck } from '../../../reusable-components/scopes';
import { useSnackbar } from '../../../reusable-components/snackbar';
import { markMetricAddedIfCounted, markMetricRemoved, NotificationMetricType } from '../../../redux/slices/notifications';
import { fCurrency } from '../../../utils/formatNumber';
import CustomToolbar from './CustomToolbar';
import RentalItemsNotesModal from './RentalItemNotesModal';
import { RentalLog } from './RentalLog';
import RentalTicket from './RentalTicket';

RentalOrderItemsView.propTypes = {
    orderId: PropTypes.number,
};

export default function RentalOrderItemsView({ orderId }) {
    const navigate = useNavigate();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const {
        data: { pendingRentals, currentRentals, previousRentals, rentalRecipients, residentsList },
    } = useSelector((state) => state.rentals);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [rows, setRows] = useState([]);
    const [isApproveAllowed, setIsApproveAllowed] = useState(false);
    const [openSidebar, setOpenSidebar] = useState(true);
    const dispatch = useDispatch();
    const [isOrderRejected, setIsOrderRejected] = useState(false);
    const [splitOrder, setSplitOrder] = useState(false);
    const [selectToSplit, setSelectToSplit] = useState([]);
    const [selectedToAdd, setSelectedToAdd] = useState([]);
    const [copied, setCopied] = useState(false);
    const [rentals, setRentals] = useState([]);
    const [value, setValue] = useState(null);
    const [recipientList, setRecipientList] = useState([]);
    const [expand, setExpand] = useState(true);
    const [openOrderApproveModal, setOpenOrderApproveModal] = useState(false);
    const [openAddRecipientsModal, setOpenAddRecipientsModal] = useState(false);
    const [editCCUsers, setEditCCUsers] = useState(false);
    const [editingPersonFor, setEditingPersonFor] = useState(false);
    const [orderTotal, setOrderTotal] = useState(0);
    const [openEmailDialog, setOpenEmailDialog] = useState(false);
    const [dialogContent, setDialogContent] = useState('');
    const [inputValue, setInputValue] = useState("");
    const location = useLocation();
    const orderStatus = location.pathname.split('/').pop().toLowerCase();
    const [openTicket, setOpenTicket] = useState('close');
    const [currentTicket, setCurrentTicket] = useState(0);
    const [addItemsToTicket, setAddItemsToTicket] = useState(false);
    const [isConfirmMode, setIsConfirmMode] = useState(false);
    const [isRequestMode, setIsRequestMode] = useState(false);
    const [selectedRowsToClose, setSelectedRowsToClose] = useState([]);
    const [allRequested, setAllRequested] = useState(false);
    const [selectedRowsToPickup, setSelectedRowsToPickup] = useState([]);
    const hasFacilityAccess = useScopeCheck(['Facility-Manager'], true);
    const [hasEditAccess, setHasEditAccess] = useState(false);
    const [managerParams, setManagerParams] = useState(null);
    const [isPunchoutOrder, setIsPunchoutOrder] = useState(false);
    const [searchParams] = useSearchParams();
    const userId = searchParams.get('userId');
    const back = searchParams.get('back');
    const punchoutEditAccess = useScopeCheck(['Rental-Order-Punchout'], true);
    const submitEditAccess = useScopeCheck(['Rental-Order-Submit'], true);

    ApprovedCell.propTypes = {
      row: PropTypes.object.isRequired,
      isApproveAllowed: PropTypes.bool.isRequired,
    };

    function ApprovedCell({ row, isApproveAllowed }) {
        const [isChecked, setIsChecked] = useState(row.itemId !== 0 && row.vendorId !== 0 && row.deleted !== true);
        const handleChange = () => {
            const newValue = !isChecked;
            setIsChecked(newValue);
            dispatch(updateOrderItemInRedux(row.cartItemId, newValue));
        };
        return <Switch disabled={!isApproveAllowed} color="info" checked={isChecked} onChange={handleChange} />;
    };

    SerialNumberCell.propTypes = {
      row: PropTypes.object.isRequired
    };

    function SerialNumberCell({ row }) {
    const [isEditing, setIsEditing] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [serialNumberValue, setSerialNumberValue] = useState(row?.serialNumber ?? '');

    useEffect(() => {
      setSerialNumberValue(row?.serialNumber ?? '');
    }, [row?.serialNumber]);

    const handleSave = async () => {
      setIsSaving(true);
      const saved = await handleEditSerialNumber(row.cartItemId, serialNumberValue);
      setIsSaving(false);
      if (saved) setIsEditing(false);
    };

     return  <div style={{ display: 'flex', alignItems: 'center', width: '100%', height: '100%' }}>
                {isEditing ? (
                  <>
                    <TextField
                      value={serialNumberValue}
                      onChange={e => setSerialNumberValue(e.target.value)}
                      size="small"
                      sx={{ width: 80, mr: 1 }}
                      autoFocus
                    />
                    <IconButton
                      color="primary"
                      size="small"
                      disabled={isSaving}
                      onClick={handleSave}
                    >
                      <Iconify icon="mdi:check" />
                    </IconButton>
                  </>
                ) : (
                  <>
                    <Typography variant="body2" sx={{ mr: 1 }}>{serialNumberValue}</Typography>
                    <IconButton
                      size="small"
                      onClick={() => setIsEditing(true)}
                    >
                      <Iconify icon="mdi:pencil" />
                    </IconButton>
                  </>
                )}
              </div>  
    }
    const selectedRowsToSplit = useMemo(
        () => rows?.filter((row) => selectToSplit.includes(row?.cartItemId)),
        [rows, selectToSplit]
    );

    const formatName = (str) =>
        typeof str === 'string' && str.length > 0
            ? str
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(' ')
            : str;

    useEffect(() => {
        const trackViewAndRefreshUnread = async () => {
            const result = await dispatch(
                addRentalLogRedux({
                    rentalId: orderId,
                    messageType: 'View',
                })
            );
            if (result === 'success') {
                dispatch(getUnreadRentalCount());
            }
        };

        trackViewAndRefreshUnread();
    }, [dispatch, orderId]);

    useEffect(() => {
      if(openTicket === 'open') {
        setExpand(false);
      }
      else {
        setExpand(true);
      }
    }, [openTicket])

    const handleSaveRecipients = async () =>
      dispatch(postAddCopiedUsers(recipientList, orderId, orderStatus))
      .then((response) => {
        if (response?.success === true) {
          enqueueSnackbar('Recipients added successfully', { variant: 'success' });
          setRecipientList([]);
        } else {
          enqueueSnackbar('Failed to add recipients', { variant: 'error' });
          setRecipientList([]);
        }
      })
      .catch(() => {
        enqueueSnackbar('Error adding recipients', { variant: 'error' });
        setRecipientList([]);
    });

    const handleEditSerialNumber = async (cartItemId, newSerialNumber) => {
      try {
        const response = await dispatch(editSerialNumber(cartItemId, newSerialNumber, isPunchoutOrder));
        if (response?.success === true) {
          enqueueSnackbar('SerialNumber updated successfully', { variant: 'success' });
          await dispatch(getRentalOrdersRedux(orderStatus));
          return true;
        }
        enqueueSnackbar('Failed to update SerialNumber', { variant: 'error' });
      }catch (error) {
        enqueueSnackbar(`Error updating SerialNumber`, { variant: 'error' });
      }
      return false;
    };
    const handleUpdatePersonFor = (_, newResident) => {
      if (!newResident) return;
      dispatch(editPersonFor(orderId, newResident.id)).then((response) => {
        if (response?.success) {
          setEditingPersonFor(false);
          enqueueSnackbar('Person For updated successfully', { variant: 'success' });
        } else {
          enqueueSnackbar('Failed to update Person For', { variant: 'error' });
        }
      });
    };

    const handleSaveRecipient = (user) => {
      if (typeof user === 'string') {
        user = { email: user, name: user };
      }
      dispatch(postAddCopiedUsers( [user], orderId, orderStatus ));
    }

    useEffect(() => {
      if ((orderStatus.toLowerCase() === 'current' && currentRentals?.length === 0) ||
          (orderStatus.toLowerCase() === 'previous' && previousRentals?.length === 0) ||
          (orderStatus.toLowerCase() === 'pending' && pendingRentals?.length === 0)) 
      {
          dispatch(getRentalOrdersRedux(orderStatus));
      }
    }, [orderStatus]);

    useEffect(() => {
        setRentals(
            orderStatus.toLowerCase() === 'pending'
                ? pendingRentals
                : orderStatus.toLowerCase() === 'current'
                    ? currentRentals
                    : previousRentals
        );
    }, [orderStatus, pendingRentals, currentRentals, previousRentals]);

    useEffect(() => {
        setSelectedOrder(rentals?.find((order) => order.orderId === orderId));
        const total = rentals
            ?.filter((order) => order.orderId === orderId)
            ?.reduce((sum, order) => sum + (order.total || 0), 0);
        setOrderTotal(total);
        setIsPunchoutOrder(rentals?.some((order) => order.orderId === orderId && order.itemId === 0));
    }, [rentals])

    useEffect(() => {
      setHasEditAccess(isPunchoutOrder ? punchoutEditAccess : submitEditAccess);
    }, [isPunchoutOrder, punchoutEditAccess, submitEditAccess])
    useEffect(() => {
      setAllRequested(rows.every(row => !!row.requestedPickupOn));
    }, [rows])

    const { addNewTabAndNavigate } = useTabs();
    const updateOrderItem = async (cartItemId, action, successMessage) => {
      try {
        const response = await updateRentalOrder({ orderId, cartItemId, action });
        if(response?.status === 200 && response?.data?.success) {
          enqueueSnackbar(successMessage, { variant: 'success' });
          dispatch(getRentalOrdersRedux(orderStatus));
        } else {
          enqueueSnackbar(response?.data?.message || 'Failed to update item', { variant: 'error' });
        }
      } catch (error) {
        enqueueSnackbar(`Error updating item: ${error.message}`, { variant: 'error' });
      }
    };
    useEffect(() => {
        dispatch(getRentalRecipientsRedux(orderId));
    }, [dispatch]);

    const handleChange = (event, newValue, reason) => {
        let newValueObject;
        if (newValue === null) return;
        if (reason === "removeOption") {
            setRecipientList(prevList => prevList.filter(item => item.email === newValue.email));
            return;
        }
        if (typeof newValue === 'string') {
            newValueObject = { email: newValue, name: newValue };
        }
        else if (Array.isArray(newValue)) {
            newValueObject = { email: newValue[newValue.length - 1]?.email, name: newValue[newValue.length - 1]?.name };
        }
        else {
            newValueObject = { email: newValue?.email, name: newValue?.name };
        }
        if (!recipientList.some(item => item.email === newValueObject.email)) {
            setRecipientList([...recipientList, newValueObject]);
        }
    };

    const splitOrderFunction = async () => {
        const cartItemIds = selectedRowsToSplit.map((row) => row.cartItemId);
        const response = isPunchoutOrder ? await postSplitRentalPunchoutOrder({ orderId, cartItemIds }) : await postSplitRentalOrder({ orderId, cartItemIds });
        if (response.status === 200) {
            dispatch(markMetricAddedIfCounted(
                NotificationMetricType.RentalsSubmitted,
                orderId,
                response.data?.id
            ));
            dispatch(getRentalOrdersRedux('pending'));
            setSelectToSplit([]);
            setSplitOrder(false);
            enqueueSnackbar(`Order #${orderId} split ${selectedRowsToSplit?.length} items to `, {
                variant: 'success',
                autoHideDuration: 4000,
                action: (key) => (
                    <>
                        <Button
                            onClick={() => {
                                addNewTabAndNavigate(`/dashboard/rentals/rental-order/${response.data?.id}/pending`);
                            }}
                            color="secondary"
                            endIcon={<Iconify icon="material-symbols:open-in-new" />}
                        >
                            #{response.data?.id}
                        </Button>
                        <Button
                            onClick={() => {
                                closeSnackbar(key);
                            }}
                            sx={{
                                color: '#fff',
                            }}
                        >
                            X
                        </Button>
                    </>
                ),
            });
        } else {
            enqueueSnackbar('Error splitting order', { variant: 'error', persist: true });
        }
    };

    const orderedQty = {
        field: 'orderedQty',
        headerName: 'Qty',
        renderCell: (params) => <Typography>{params.row.orderedQty}</Typography>,
        flex: .5,
    };

    const canManageOrderItems = (orderStatus === 'pending' && hasEditAccess) || (orderStatus === 'current' && isApproveAllowed && !isPunchoutOrder);

    const actionsColumn = {
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      disableReorder: true,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Stack direction="row" spacing={0.5} alignItems="center">
          <RentalItemsNotesModal params={params} />
          {canManageOrderItems && (
            <>
              {orderStatus === 'current' ? (
                <ConfirmDialog
                  icon="add"
                  title="Add Item and Send to Vendor"
                  color="secondary"
                  tooltip="Add another"
                  iconButtonSx={{ color: 'secondary.main' }}
                  content="You are adding another item and sending the changes to the vendor."
                  actionButton="Add and Send to Vendor"
                  action={() => updateOrderItem(params.row.cartItemId, 'addAnother', 'Another item added')}
                />
              ) : (
                <Tooltip title="Add another">
                  <IconButton
                    sx={{ color: 'secondary.main' }}
                    onClick={() => updateOrderItem(params.row.cartItemId, 'addAnother', 'Another item added')}
                  >
                    <Iconify icon="eva:plus-outline" />
                  </IconButton>
                </Tooltip>
              )}
              {orderStatus !== 'current' && (
                <ConfirmDialog
                  icon="delete-outline"
                  title="Delete item"
                  color="error"
                  tooltip="Delete"
                  content="Are you sure you want to remove this item from the order?"
                  actionButton="Delete"
                  action={() => updateOrderItem(params.row.cartItemId, 'delete', 'Item deleted')}
                />
              )}
            </>
          )}
        </Stack>
      ),
    };

    const pendingApprovalColumn = {
        field: 'pendingApprovalColumn',
        headerName: 'Pending Approval',
        width: 180,
        renderCell: (params) => <ApprovedCell row={params.row} isApproveAllowed = {isApproveAllowed} />,
        id: 'pendingApprovalColumn',
        className: 'pendingApprovalColumn',
    };

    const longTerm = {
      field: 'longTerm',
      headerName: 'Long Term',
      minWidth: 110,
      flex: 0.75,
      renderCell: (params) => {
        const isPrevious = orderStatus === 'previous';
        const handleClick = () => {
          if (!isPrevious && hasEditAccess) {
            dispatch(updateShortLongTerm(params.row.cartItemId, isPunchoutOrder));
            dispatch(getRentalOrdersRedux(orderStatus));
          }
        };
        return params.row.longTerm ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
            <ToggleOnIcon
              color="primary"
              style={{ cursor: isPrevious || !hasEditAccess ? 'not-allowed' : 'pointer', opacity: isPrevious ? 0.5 : 1 }}
              onClick={handleClick}
            />
          </div>
        ) : (
          <div
            style={{
              color: 'grey',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: '100%',
            }}
          >
            <ToggleOffIcon
              style={{ cursor: isPrevious || !hasEditAccess ? 'not-allowed' : 'pointer', opacity: isPrevious ? 0.5 : 1 }}
              onClick={handleClick}
            />
          </div>
        );
      },
      type: 'customSelect',
    };
    const SerialNumber = {
      field: 'SerialNumber',
      headerName: 'Item SerialNumber',
      minWidth: 150,
      flex: .75,
      renderCell: (params) => (<SerialNumberCell row = {params.row} />
      )
    }
    const approvalStatusColumn = {
        field: 'approvalStatusColumn',
        headerName: 'Status',
        width: 180,
        renderCell: (params) => {
            const status = params.row.status?.trim();
            if (!status) return null;

            return (
                <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                    <Typography sx={{ color: status === 'Unapproved' ? 'error.main' : 'success.main', fontWeight: 'bold' }}>
                        {status}
                    </Typography>
                </Box>
            );
        }
    };
    const handleDelete = (email) => {
        const listToDelete = recipientList.filter((item) => item.email === email)
        if (listToDelete.length > 0) {
            setRecipientList((prevList) => prevList.filter((item) => !listToDelete.some((del) => del.email === item.email)));
        }
        else {
            dispatch(postDeleteCopiedUser(email, orderId, orderStatus))
        }
    }

    const columns = useMemo(
        () => ([...RENTAL_ORDER_ITEMS, SerialNumber, orderedQty, longTerm, orderStatus === 'pending' ? pendingApprovalColumn : approvalStatusColumn, actionsColumn]),
        [orderStatus, isApproveAllowed, canManageOrderItems]
    );

    
    const [stateAlerts, setStateAlerts] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState({});
    
    const facilityZip = selectedOrder?.facilityAddress?.trim().split(" ")[selectedOrder?.facilityAddress?.trim().split(" ").length - 1];

    useEffect (() => {
      getApproved();
    }, [selectedOrder?.facilityId])

    useEffect(() => {
      if (editingPersonFor && selectedOrder?.facilityId) {
        dispatch(getResidentsForFacility(selectedOrder.facilityId));
      }
    }, [editingPersonFor, selectedOrder?.facilityId]);

    useEffect(() => {
        const filteredRows = rentals.filter((item) => item.orderId === orderId);
        let sortedRows = filteredRows;
        if (orderStatus === 'previous') {
          sortedRows = [...filteredRows].sort((a, b) => {
            if (a.closedOn && !b.closedOn) return -1;
            if (!a.closedOn && b.closedOn) return 1;
            return 0;
          });
        } else {
          sortedRows = [...filteredRows].sort((a, b) => {
            if (a.closedOn && !b.closedOn) return 1;
            if (!a.closedOn && b.closedOn) return -1;
            return 0;
          });
        }
        setRows(sortedRows);
        setDataLoaded(true);
    }, [orderId, rentals, selectedOrder]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const stateAlert = await getStateAlerts(facilityZip);
                setStateAlerts(stateAlert?.headlines ?? []);
            } catch (error) {
                console.error('Error fetching state alerts:', error);
                setStateAlerts([]);
            }
        };
        if (facilityZip) {
            fetchData();
        }
    }, [facilityZip]);

    const approvedOnDate = new Date(selectedOrder?.approvedOn);
    const today = new Date();
    const diffInDays = Math.floor((today - approvedOnDate) / (1000 * 60 * 60 * 24));
    const getApproved = async () => {
      try {
            const response = await postIsApproveEnabled(selectedOrder?.facilityId, isPunchoutOrder);
            if (response.data.success) {
                setIsApproveAllowed(true);
              }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {
      if (!selectedOrder?.orderId) {
        dispatch(getRentalOrdersRedux(orderStatus));
      }
    }, [selectedOrder])
    const bumpRentalsNeedApproval = () => dispatch(markMetricRemoved(NotificationMetricType.RentalsNeedApproval, orderId));

    const approveOrder = async () => {
        if (recipientList.length > 1) await handleSaveRecipients();
        setOpenOrderApproveModal(false);
        dispatch(updateOrderStatus(rows, isOrderRejected, orderId, isPunchoutOrder))
        .then((response) => {
          const message = response?.data?.message;
          const succeeded = response?.status === 200 && message === "Success";
          const rejected = message === "Rejected";

          if (succeeded || rejected) bumpRentalsNeedApproval();

          if (succeeded) {
            enqueueSnackbar('Order approved successfully', { variant: 'success' });
            setRecipientList([]);
          } else if (rejected) {
            enqueueSnackbar('Order rejected', { variant: 'error' });
          } else {
            enqueueSnackbar('Failed to approve order', { variant: 'error' });
            setRecipientList([]);
          }
        })
        .catch(() => {
          enqueueSnackbar('Failed to approve order', { variant: 'error' });
          setRecipientList([]);
        });
        navigate(`/dashboard/rentals/pending-rentals`);
    };
    const selectedRows = useMemo(() => rows?.filter((row) => selectedToAdd.includes(row.cartItemId)), [rows, selectedToAdd]);
    const uniqueEmails = [...new Set(dialogContent?.vendorRec ? Object.values(dialogContent.vendorRec).flat() : [])];
    const CustomLeftToolbar = useCallback(() => {
        if (rows.length === 0) return null;
        return (
          !addItemsToTicket
            ? (
          <CustomToolbar
            allRequested = {allRequested}
            approveOrder={approveOrder}
            orderId={orderId}
            rows={rows}
            setSplitOrder={setSplitOrder}
            facility={selectedOrder?.facilityId}
            residentId={selectedOrder?.residentId}
            isApproveAllowed={isApproveAllowed}
            setSelectedRowsToClose={setSelectedRowsToClose}
            setSelectedRowsToPickup={setSelectedRowsToPickup}
            setIsConfirmMode={setIsConfirmMode}
            setIsRequestMode={setIsRequestMode}
            selectedRowsToClose={selectedRowsToClose}
            isConfirmMode={isConfirmMode}
            selectedRowsToPickup={selectedRowsToPickup}
            isRequestMode={isRequestMode}
            setIsOrderRejected={setIsOrderRejected}
            setOpenOrderApproveModal={setOpenOrderApproveModal}
            isPunchoutOrder={isPunchoutOrder}
          />
              )
            : (
          <Box sx={{ display: 'flex', mx: 1 }}>
            <Typography variant="subtitle1">Select items to add to ticket</Typography>
            <Typography
              variant="subtitle1"
              color="secondary"
              sx={{ cursor: 'pointer', textDecoration: 'underline', ml: 1 }}
              onClick={() => { setAddItemsToTicket(false); }}
            >
              Cancel
            </Typography>
          </Box>
              )
        );
    }, [rows, addItemsToTicket, isConfirmMode, isRequestMode, isApproveAllowed, selectedOrder, selectedRowsToClose, selectedRowsToPickup]);


    const updateManagerParamsRows = (updatedRow) => {
        setManagerParams(prev => ({
            ...prev,
            row: {
                ...prev.row,
                ...updatedRow[0],
            }
        }));
    }

    useEffect(() => {
        setManagerParams({
            row: {
                facilityManagerAssignments: selectedOrder?.facilityManagerAssignments,
                facilityId: selectedOrder?.facilityId,
                id: orderId,
            },
            api: { updateRows: updateManagerParamsRows }
        })
    }, [selectedOrder?.facilityManagerAssignments, selectedOrder?.facilityId, orderId]);

    return (
      <>
      <Dialog
        open={openEmailDialog}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
          setOpenEmailDialog(false);
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ textAlign: 'center',  fontWeight: 'bold' }}>
          <Box color="info.main">
              Email Details  <Iconify icon={`line-md:email`} width={20} height={20} />  <CloseIconButton onClick={() => setOpenEmailDialog(false)} />
          </Box>
        </DialogTitle>
        <DialogContent sx={{ padding: 5 }}>
          <Box sx={{ mb: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 'bold', marginTop:"10px" }} color="info.main">
              Subject:
            </Typography>
              {dialogContent?.subject}
          </Box>
          <Divider sx={{ bgcolor: 'rgb(145, 158, 171)' }} />
          <Box sx={{ mb: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 'bold', marginTop:"10px" }} color="info.main">
              Recipients:
            </Typography>
              {uniqueEmails
                  .map(email => email.trim())
                  .join(', ')}
          </Box>
          <Divider sx={{ bgcolor: 'rgb(145, 158, 171)' }} />
            <Box sx={{ mb: 1 }}>
              <Typography variant="body2" sx={{ fontWeight: 'bold', marginTop:"20px" }} color="info.main">
                Body:
              </Typography>
              <div dangerouslySetInnerHTML={{ __html: dialogContent?.body }} />
            </Box>
        </DialogContent>
      </Dialog>
        <Grid container alignItems="center" spacing={1} marginBottom={1}>
          <Grid item display = "flex" justifyContent={"flex-start"}>
            <Button
              variant="text"
              onClick={() => {
                dispatch(clearFacilityVendors());
                if(back === "userRentals" && userId){
                  navigate(`/dashboard/admin/users/${userId}?tab=5`);
                  return;
                }
                if (back === 'allRentalItems') {
                  navigate(`/dashboard/rentals/${orderStatus}-rentals?view=allItems`);
                  return;
                }
                navigate(`/dashboard/rentals/${orderStatus}-rentals`);
              }}
              startIcon={<Iconify icon="mingcute:left-fill" width={24} height={24} sx = {{ mx: -1 }} />}
              sx = {{
                color: '#454F5B',
                fontWeight: 'bold',
              }}
            >
              {back === "userRentals" && userId
                ? "Back to User Rentals"
                : back === 'allRentalItems'
                ? "Back to All Rental Items"
                : `Back to ${orderStatus.toLowerCase()} Rentals`}
            </Button>
          </Grid>
          <Grid item display = "flex" justifyContent={"center"} textAlign={"center"} style = {{marginLeft: "300px"}} >
            <Typography variant="subtitle1" sx = {{ color: '#8dc63f', fontWeight: 'bold', fontSize: '15px', mr: 2 }}>
              Rental Order {selectedOrder?.orderNumber} - {formatName(selectedOrder?.personFor)} {selectedOrder?.residentDeleteFlag ? '(Deleted)' : ''}
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start">
          <Grid item sx = {{ width: openSidebar ? '78%' : '95%' }}>
            <Grid container>
              {splitOrder && (
                <Grid item xs={2}>
                  <Box sx = {{ ml: 2, p: 1.5, mt: 7 }}>
                    <AwaitButton
                      variant="outlined"
                      color="primary"
                      fullWidth
                      sx = {{ mb: 1, width: '180px', boxShadow: 3, fontWeight: 'bold' }}
                      startIcon={<MergeTypeIcon />}
                      onClick={splitOrderFunction}
                    >
                      Split from {orderId}
                    </AwaitButton>
                    <Box sx = {{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                      {selectedRowsToSplit.map((row, index) => (
                        <Box key={index}>
                          <Box
                            sx = {{
                              display: 'flex',
                              alignItems: 'center',
                              border: 'solid 2px #b128bc',
                              width: '180px',
                              height: 'auto',
                              mr: 1,
                            }}
                          >
                            <Box
                              sx = {{
                                width: 'auto',
                                backgroundColor: 'secondary.main',
                                display: 'flex',
                                height: '100%',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#fff',
                                pr: '2px',
                              }}
                            >
                              {index + 1}
                            </Box>
                            <Box sx = {{ ml: 1, color: 'secondary.main', fontSize: '0.8rem' }}>{row.description}</Box>
                          </Box>
                          {index < selectedRowsToSplit?.length - 1 && (
                            <Box
                              sx = {{
                                width: '2px',
                                height: '20px',
                                backgroundColor: '#b128bc',
                                alignSelf: 'center',
                                ml: 1,
                              }}
                            />
                          )}
                        </Box>
                      ))}
                    </Box>
                    <Grid container direction="row" justifyContent="flex-end" alignItems="center">
                      <Grid item xs={6}>
                        <Button
                          variant="text"
                          color="inherit"
                          sx = {{ mb: 1, width: '100%', textDecoration: 'underline' }}
                          onClick={() => {
                            setSelectToSplit([]);
                            setSplitOrder(false);
                          }}
                        >
                          Cancel
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              )}
              <Grid item xs={splitOrder > 0 ? 10 : 12}>
                <CustomDataGrid
                  forceReRender={[isApproveAllowed, canManageOrderItems]}
                  gridId="pending-rentals-order"
                  applyQuickFilter
                  checkboxSelection={isConfirmMode || splitOrder || !!addItemsToTicket || isRequestMode}
                  boxSX = {{ width: '100%', height: 'calc(100vh - 260px)' }}
                  data={rows}
                  getRowId={(row) => row?.cartItemId}
                  gridColumns={columns}
                  dontGetRowHeight
                  pinnedColumns={{
                        right: ['approvalStatusColumn', 'actions'],
                      }}
                  sx={{
                    '& .MuiDataGrid-cell[data-field="actions"], & .MuiDataGrid-columnHeader[data-field="actions"]': {
                      paddingRight: 0,
                    },
                  }}
                  getRowClassName={(params) => (params.row.vendorId === 0 || params.row.deleted === true ? 'disabled' : '')}
                  disableRowSelectionOnClick
                  keepNonExistentRowsSelected
                  onRowSelectionModelChange={(newSelection) => {
                    if (isConfirmMode) {
                      const rowApprovedStatus = rows.find(
                        (row) => newSelection[newSelection.length - 1] === row?.cartItemId
                      )?.approvedOn;
                      if (rowApprovedStatus || newSelection.length === 0) {
                        setSelectedRowsToClose(newSelection);
                      } else {
                        enqueueSnackbar("Can't close an unapproved rental", { variant: 'error' });
                      }
                    }  else if (isRequestMode) {
                      const rowApprovedStatus = rows.find(
                        (row) => newSelection[newSelection.length - 1] === row?.cartItemId
                      )?.approvedOn;
                      if (rowApprovedStatus || newSelection.length === 0) {
                        setSelectedRowsToPickup(newSelection);
                      } else {
                        enqueueSnackbar("Can't request pickup on an unapproved rental", { variant: 'error' });
                      }
                    }else if (splitOrder) {
                      setSelectToSplit(newSelection);
                    }
                    else if (addItemsToTicket) {
                      setSelectedToAdd(newSelection);
                    }
                  }}
                  rowSelectionModel={isConfirmMode ? selectedRowsToClose : addItemsToTicket ? selectedToAdd : isRequestMode ? selectedRowsToPickup : selectToSplit}
                  isLoading={!dataLoaded}
                  sort={[{ field: 'name', sort: 'asc' }]}
                  CustomLeftToolbar={CustomLeftToolbar}
                  isRowSelectable={(params) => {
                      if (isRequestMode) {
                       return params.row.approvedOn && !params.row.requestedPickupOn && !params.row.closedOn;
                      }
                      return !(params.row.vendorId === 0 || params.row.deleted === true);
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item sx = {{ width: openSidebar ? '22%' : '5%' }}>
            <CollapseSidebar openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
            <Box
              sx={{height: 'calc(100vh - 260px)' , display: 'flex', flexDirection: 'column', overflow: 'auto', paddingRight: '3px'}}
              className='hover-scrollbar'
            >
              {openSidebar && (
                <Grid item justifyContent="flex-end">
                  <Grid container justifyContent="flex-end" direction="column" sx = {{ width: '100%'}}>
                    <Card sx = {{ padding: 1, justifyContent: 'flex-end', alignItems: 'center'}}>
                      <Grid item >
                        <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}  onClick={() => setExpand(!expand)}>
                          <Typography
                            alignItems="left"
                            justifyContent="left"
                            variant="subtitle1"
                            sx = {{color: 'info.main', fontWeight: 'bold', fontSize: '15px', cursor: 'pointer' }}
                          >
                            Rental Request Details
                          </Typography>
                          <Tooltip title={`${!expand ? 'expand' : 'collapse'}`}>
                            <IconButton
                              sx = {{ color: 'info.main', height: 'fit-content' }}
                            >
                              <Iconify icon={`ic:twotone-expand-${expand ? 'less' : 'more'}`} width={20} height={20} />
                            </IconButton>
                          </Tooltip>
                        </Stack>
                      </Grid>
                    {expand && (<Grid sx = {{ textAlign: 'left', paddingTop: 1, paddingLeft:2 }} >                  
                        <Grid item sx = {{ textAlign: 'left' }}>
                          <Typography sx = {{ mr: 2, fontSize: '12px' }}>
                            <Iconify sx = {{ mr: 0.5 }} icon="tdesign:building" width={16} height={16} color="secondary" />
                            {selectedOrder?.facilityName}
                          </Typography>
                          {stateAlerts.length > 0 && (
                            <Tooltip title={stateAlerts[0]?.headline || 'Weather Alert'}>
                              <IconButton
                                color="error"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  window.open(
                                    `https://weather.com/weather/today/l/${selectedOrder?.facilityStreet},${selectedOrder?.facilityCityStateZip}
                                      ?.trim()
                                      .split(' ')
                                      .pop()}`,
                                    '_blank'
                                  );
                                }}
                                size="small"
                                sx = {{ ml: 0.5 }}
                              >
                                <Iconify icon={stateAlerts[0]?.icon} width={24} height={16} />
                              </IconButton>
                          </Tooltip>
                          )}
                        </Grid>
                        <Grid item sx = {{ textAlign: 'left' }}>
                            <Iconify sx = {{ mr: 0.5 }} icon="grommet-icons:map" width={16} height={16} color="secondary" />
                            <Box
                              sx = {{
                                ml: 3,
                                mt: -2,
                                textDecoration: 'underline',
                                color: 'primary.main',
                                cursor: 'pointer',
                              }}
                              onClick={() =>
                                window.open(
                                  `https://www.google.com/maps/place/${selectedOrder?.facilityStreet}, ${selectedOrder?.facilityCityStateZip}`,
                                  '_blank',
                                  'noopener,noreferrer'
                                )
                              }
                            >
                              <Typography sx = {{ py: 0.5 }} component="span" variant="body2">
                                  <Typography
                                    variant="body2"
                                    display="block"
                                  >
                                    {selectedOrder?.facilityStreet}
                                  </Typography>
                                  </Typography> 
                                <Typography
                                  variant="body2"
                                  color={ 'primary.main'}
                                  display="block"
                                >
                                  {`${selectedOrder?.facilityCityStateZip}`}
                                </Typography>
                            
                                <Typography
                                  variant="body2"
                                  color={'primary.main'}
                                  display="block"
                                >
                                  {selectedOrder?.facilityPhone}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item sx = {{ textAlign: 'left' }}>
                          <Typography component="span" sx = {{ mr: 2, fontSize: '12px' }} variant="body2">
                            {selectedOrder?.facilityManagerAssignments && (
                              <Typography variant="subtitle2" display="inline">
                                  <Iconify sx={{ mr: 0.5 }} icon="hugeicons:manager" width={16} height={16} color="secondary" />
                                  Managers:
                                  {hasFacilityAccess && !!managerParams?.row && !!managerParams?.api ?
                                      <ManagerChips
                                          params={managerParams}
                                          type="Rentals"
                                          hasFacilityAccess={hasFacilityAccess}
                                          facilityManagers={selectedOrder?.facilityManagerAssignments}
                                          refetch={() => dispatch(getRentalOrdersRedux(orderStatus))}
                                          onDeleteSuccess={() => enqueueSnackbar('Manager deleted successfully', { variant: 'success' })}
                                      /> : selectedOrder?.facilityManagerAssignments?.map((manager) => <Chip key={manager.modelId}
                                          label={manager.manager}
                                          color="primary" size="small" sx={{ ml: 1 }} />)}
                                </Typography>
                              )}
                          </Typography>
                        </Grid>
                        <Grid item sx = {{ textAlign: 'left' }}>
                          <Typography sx = {{ mr: 2, fontSize: '12px' }}>
                            <Iconify sx = {{ mr: 0.5 }} icon="mingcute:store-line" width={16} height={16} color="secondary" />
                            Vendor: {selectedOrder?.vendor}
                          </Typography>
                        </Grid>
                        <Grid item sx = {{ textAlign: 'left' }}>
                          <Box sx = {{ display: 'flex', alignItems: 'center' }}>
                            <Iconify sx = {{ mr: 0.5 }} icon="mdi:user-outline" width={16} height={16} color="secondary" />
                            {editingPersonFor ? (
                              <Autocomplete
                                autoFocus
                                openOnFocus
                                options={
                                  residentsList
                                    ?.filter((resident) => resident.facilityId === selectedOrder?.facilityId)
                                    ?.sort((a, b) => `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`)) ?? []
                                }
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                getOptionKey={(resident) => resident.id}
                                getOptionLabel={(resident) =>
                                  `${resident.firstName} ${resident.lastName}${
                                    resident.dob ? ` (DOB: ${new Date(resident.dob).toLocaleDateString('en-US')})` : ''
                                  }`
                                }
                                onChange={handleUpdatePersonFor}
                                onBlur={() => setEditingPersonFor(false)}
                                sx = {{ minWidth: 180, maxWidth: 220 }}
                                renderOption={(props, resident) => (
                                  <li {...props}>
                                    <Box sx = {{ display: 'flex', flexDirection: 'column' }}>
                                      <span>{resident.firstName} {resident.lastName}</span>
                                      {resident.dob && (
                                        <Typography component="span" sx = {{ fontSize: '10px' }} color="text.secondary">
                                          DOB: {new Date(resident.dob).toLocaleDateString('en-US')}
                                        </Typography>
                                      )}
                                    </Box>
                                  </li>
                                )}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="standard"
                                    placeholder="Select resident"
                                    autoComplete="off"
                                    size="small"
                                    sx = {{ '& .MuiInputBase-input': { fontSize: '12px' } }}
                                  />
                                )}
                              />
                            ) : (
                              <Typography component="span" sx = {{ mr: 2, fontSize: '12px' }}>
                                Resident: {selectedOrder?.personFor}
                              </Typography>
                            )}
                            {hasEditAccess && !editingPersonFor && (
                              <IconButton size="small" onClick={() => setEditingPersonFor(true)}>
                                <Iconify icon="mdi:pencil-outline" width={14} height={14} />
                              </IconButton>
                            )}
                          </Box>
                          <Typography sx = {{ mr: 2, fontSize: '12px' }}>
                            <Iconify sx = {{ mr: 0.5 }} icon="cil:room" width={16} height={16} color="secondary" />
                            Room: {selectedOrder?.room}
                          </Typography>
                        </Grid>
                        <Grid item sx = {{ textAlign: 'left' }}>
                          <Typography component="span" sx = {{ fontSize: '12px', mr: '3px' }} variant="body2">
                            <Iconify sx = {{ mr: 0.5 }} icon="mdi:user-outline" width={16} height={16} color="secondary" />
                            Submitted by:
                          </Typography>
                          <Tooltip title={copied ? `Copied!` : `Copy ${selectedOrder?.addedBy || ''} to clipboard`}>
                            <Typography
                              component="span"
                              sx = {{
                                mr: 2,
                                fontSize: '12px',
                                textDecoration: 'underline',
                                '&:hover': { cursor: 'pointer' },
                              }}
                              variant="body2"
                              onClick={() => {
                                navigator.clipboard.writeText(selectedOrder?.addedBy);
                                setCopied(true);
                              }}
                            >
                              {selectedOrder?.onBehalfOf} <Iconify icon={'ph:copy'} sx = {{ pt: 0.5 }} />
                            </Typography>
                          </Tooltip>
                        </Grid>
                        <Grid item sx = {{ textAlign: 'left' }}>
                          <Typography component="span" sx = {{ fontSize: '12px', mr: '3px' }} variant="body2">
                            <Iconify sx = {{ mr: 0.5 }} icon="uiw:date" width={16} height={16} color="secondary" />
                            Submitted on:
                          </Typography>
                          <Typography component="span" sx = {{ ml: 0.5 }} variant="body2">
                            {selectedOrder?.dateAdded
                              ? `${new Date(selectedOrder?.dateAdded).toLocaleDateString('en-US', {
                                  year: 'numeric',
                                  month: 'short',
                                  day: 'numeric',
                                })} EST`
                              : ''}
                          </Typography>
                        </Grid>
                        <Grid item sx = {{ textAlign: 'left' }}>
                          <Typography component="span" sx = {{ fontSize: '12px' }} variant="body2">
                            <Iconify sx = {{ mr: 0.5 }} icon="bx:category-alt" width={16} height={16} color="secondary" />
                            Category:
                          </Typography>
                          <Typography component="span" sx = {{ mr: 2, fontSize: '12px' }} variant="body2">
                            {' '}
                            {selectedOrder?.department}{' '}
                          </Typography>
                        </Grid>
                        {orderStatus === 'current' && (
                          <Typography sx = {{ mr: 2, fontSize: '12px' }}>
                            <Iconify
                              sx = {{ mr: 0.5 }}
                              icon="material-symbols-light:timelapse-outline"
                              width={16}
                              height={16}
                              color="secondary"
                            />
                            {diffInDays} days
                          </Typography> 
                        )}
                        <Grid item sx = {{ textAlign: 'left' }}>
                          <Typography component="span" sx = {{ fontSize: '12px', mr: '3px' }} variant="body2">
                            <Iconify sx = {{ mr: 0.5 }} icon="hugeicons:manager" width={16} height={16} color="secondary" />
                            CC'ed Users:
                          </Typography>
                          <Box sx = {{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 0.5 }}>
                            <Chip sx ={{mb:.5}} label = {selectedOrder?.vendor} />
                            {selectedOrder?.ccUsers?.length > 0 
                              && selectedOrder?.ccUsers?.map((user) => <Chip onDelete = {() => handleDelete(user.email)} sx ={{mb:.5}} key = {user.email} label ={user.name}/>)}
                           {hasEditAccess && <IconButton
                                color="secondary"
                                onClick = {(e) => setEditCCUsers(e.currentTarget)}
                                sx = {{ color:'secondary.main'}}
                              >
                              <Iconify color = "secondary"  sx = {{height: "20px"}} icon = "mynaui:plus"/>
                            </IconButton>}
                          </Box>
                        </Grid>
                      </Grid>)}
                      <Popover
                        open={Boolean(editCCUsers)}
                        anchorEl={editCCUsers}
                        onClose={() => setEditCCUsers(null)}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                        PaperProps={{ sx: { p: 0, mt: 1.5, ml: 0.75 } }}
                      >
                        <Box sx = {{ p: 2, maxWidth: 400, minWidth: 400, overflow: 'hidden' }}>
                          {' '}
                          <Autocomplete
                            id="tags-outlined"
                            options={
                            rentalRecipients.length > 0
                              ? rentalRecipients?.filter((x) => !selectedOrder?.ccUsers?.some((y) => y.email === x.email))
                              : []
                            }
                            onChange={(e, newValue) => {
                              handleSaveRecipient(newValue);
                              setValue(null);
                              setInputValue("");
                            }}
                            getOptionLabel={(option) => option.name} 
                            filterSelectedOptions
                            freeSolo      
                            value = {value}  
                            inputValue = {inputValue !== undefined ? inputValue : ""}                
                            renderTags={() => null}
                            onInputChange={(event, newInputValue) => {
                              setInputValue(newInputValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Add recipients"
                                placeholder="Add user"
                                sx = {{ maxWidth: 400, minWidth: 350 }}
                                autoComplete="off"
                              />
                            )}
                          />
                        </Box>
                      </Popover>
                    </Card>
                    <Card sx = {{padding: 1, mt: 1, justifyContent: 'flex-end', alignItems: 'center', maxHeight: '50vh', overflowY: 'auto',  scrollbarWidth: 'none',   msOverflowStyle: 'none',
                        '&::-webkit-scrollbar': {
                          display: 'none', 
                        },}}>
                    <RentalLog rentalId = {orderId} openTicket = {openTicket} setDialogContent = {setDialogContent} setOpenEmailDialog={setOpenEmailDialog}/>
                    </Card>
                  </Grid>
                </Grid>
              )}
              <Box sx={{
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end',
                minHeight: openTicket === 'close' ? 0 : '50vh',
                position: openTicket === 'close' ? 'sticky' : 'inherit',
                mt: 2,
              }}>
                <RentalTicket
                  currentTicket={currentTicket}
                  setCurrentTicket={setCurrentTicket}
                  openTicket={openTicket}
                  setOpenTicket={setOpenTicket}
                  addItemsToTicket={addItemsToTicket}
                  setAddItemsToTicket={setAddItemsToTicket}
                  selectedRows={splitOrder ? [] : selectedRows}
                  setSelected={setSelectedToAdd}
                  openSidebar={openSidebar}
                  setOpenSidebar={setOpenSidebar}
                  rentalId = {orderId}
                  orderStatus = {orderStatus}
                />
              </Box>
            </Box>
          </CollapseSidebar>
        </Grid>
       </Grid>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={openOrderApproveModal}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
          setOpenOrderApproveModal(false);
        }}
      >
        <DialogTitle sx = {{ textAlign: 'center' }} color = "info.main">
          Rental Order Summary <CloseIconButton onClick={() => setOpenOrderApproveModal(false)} />
          <Box sx = {{ fontSize: '15px', fontWeight: 'normal', color: (theme) => theme.palette.grey[800] }}>
            {selectedOrder?.facilityName}{' '}
            <Box color="info.main" component="span">|</Box>
            {' '}Rental Order #: {selectedOrder?.orderNumber}
          </Box>
        </DialogTitle>
        <DialogContent sx = {{ typography: 'body2' }}>
          <Box sx = {{ mb: 1 }}>
            <Typography variant="body2" sx = {{ fontWeight: 'bold' }} color="info.main">
              Delivery Order Address:
            </Typography>
            {`${selectedOrder?.facilityStreet} ${selectedOrder?.facilityCityStateZip }`.trim()}
          </Box>
          <Divider sx = {{ bgcolor: 'rgb(145, 158, 171)' }} />
          <Box sx = {{ mt: 1 }}>
            <Typography variant="body2" sx = {{ fontWeight: 'bold' }} color="info.main">
              Vendor:
            </Typography>
            <Typography variant="body2" sx = {{ fontWeight: 'bold' }}>
              {selectedOrder?.vendor}:
            </Typography>
            <Box display="flex" alignItems="center">
              Total: {fCurrency(orderTotal)}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Stack direction="row" spacing={1} paddingBottom={2}>
            <Button onClick={() => {setOpenOrderApproveModal(false); setOpenAddRecipientsModal(true);}} variant="outlined" color="primary" >Add Recipients</Button>
            <Button onClick={() => approveOrder()}  color="primary" size="small" variant="contained">Approve Order</Button>
          </Stack>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={openAddRecipientsModal}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
          setOpenAddRecipientsModal(false);
        }}
      >
        <DialogTitle sx = {{ textAlign: 'center' }} color="info.main">
            Add CC Recipients to Order  <CloseIconButton onClick={() => { setOpenAddRecipientsModal(false); setRecipientList([]) }} />
        </DialogTitle>
        <DialogContent>
          <>
            <Tooltip title={"This user will be cc'ed on correspondence regarding this rental order"}>
              <Autocomplete
                multiple
                options={
                  rentalRecipients.length > 0
                    ? rentalRecipients?.filter((x) => !selectedOrder?.ccUsers?.some((y) => y.email === x.email))
                    : []
                }
                onChange={(e, newValue, reason) => {
                  setValue('');
                  handleChange(e, newValue, reason);
                }}
                getOptionLabel={(option) => option.name}
                filterSelectedOptions
                renderInput={(params) => <TextField {...params} autoComplete="off" />}
                renderOption={(props, option) => {
                  const isSelected = recipientList.some((item) => item.email === option.email);
                  return (
                    <MenuItem {...props} key={option.value} sx = {{ borderBottom: '1px solid #ccc' }}>
                      <Grid container alignItems="center" spacing={2}>
                        <Grid item>
                          <CustomAvatar
                            name={option.name}
                            email={option.email}
                            showTooltip={false}
                            sx = {{
                              backgroundColor: '#fff',
                              color: isSelected ? 'info.main' : 'text.secondary',
                              borderColor: isSelected ? 'info.main' : 'text.secondary',
                              height: '30px',
                              width: '30px',
                              fontSize: '0.75em',
                            }}
                          />
                          </Grid>
                            <Grid item xs zeroMinWidth>
                              <Typography
                                sx = {{
                                  fontSize: '0.85em',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  color: isSelected ? 'info.main' : 'text.secondary',
                                }}
                              >
                                  {option.name}
                              </Typography>
                              <Typography
                                  sx = {{
                                    fontSize: '0.75em',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    color: isSelected ? 'info.main' : 'text.secondary',
                                  }}
                                >
                                  {option.email}
                              </Typography>
                            </Grid>{' '}
                        </Grid>
                    </MenuItem>
                  );
                }}
              />
            </Tooltip>
          </>
        </DialogContent>
        <DialogActions>
          <Stack direction="row" spacing={1} paddingBottom={2}>
            <Button onClick={() => approveOrder()} color="primary" size="small" variant="contained">Approve Order</Button>
          </Stack>
        </DialogActions>
        </Dialog>
      </>
    )
}
